import { useGetNewsSubDivisionListQuery } from '@/app/globalRedux/api/constantSlice'
import { useTranslation } from '@/app/i18n/client'
import { ListType } from '@/app/types/constantDataType'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { useParams } from 'next/navigation'

interface SubDivisionFilterType {
  values: string[]
  setvalue: (value: string) => any
}

const SubDivisionFilter = ({ values, setvalue }: SubDivisionFilterType) => {
  const { lng } = useParams<{ lng: string }>()
  const { t } = useTranslation()
  const { data: subDivisionList } = useGetNewsSubDivisionListQuery<{
    data: ListType[]
    isLoading: boolean
  }>({
    lang: lng,
  })
  return (
    <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
      <div>
        <Accordion type="single" collapsible defaultValue="sub-division">
          <AccordionItem value="sub-division">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] ">
              {t('Retail Criteria')}
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col mt-[0px] gap-[8px]">
                {subDivisionList?.map((subDivision: ListType) => (
                  <div
                    className="flex flex-row items-center gap-2"
                    key={`${subDivision.name}$`}
                  >
                    <Checkbox
                      checked={values.includes(subDivision.name)}
                      id={`criteria-checkbox-${subDivision.name}`}
                      className="border-2 border-[#e0e0e0]"
                      onClick={() => {
                        setvalue(subDivision?.name)
                      }}
                    />
                    <Label
                      htmlFor={`criteria-checkbox-${subDivision.name}`}
                      className=" cursor-pointer text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                    >
                      {t(subDivision.name)}
                    </Label>
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  )
}

export default SubDivisionFilter
